// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606050918/js/" + chunkId + "." + {"44":"26f0001e","225":"a39deb86","481":"f70531d2","486":"85e35c33","770":"d4d98b9d"}[chunkId] + ".0.8964397320391637.chunk.js";
};